(function() {
    var m = angular.module('utils');

    m.directive('plainCourses', [function() {
        return {
            require: 'ngModel',
            priority: 1,
            link: function(scope, elm, attrs, ngModel) {
                if (attrs.plainCourses) {
                    scope.$watch(attrs.plainCourses, function() {
                        var list = scope.$eval(attrs.plainCourses);
                        $(elm).html('');
                        var corI;
                        for (corI in list) {
                            $(elm).append($('<option>').val(list[corI].id).html(list[corI].title));
                        }
                        $(elm).val(ngModel.$viewValue);
                    }, true);
                }
            }
        };
    }]);
})();
